/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import defaultCfg from '../config/default.json';
import cloudCfg from '../config/cloud.json';
import cubeCfg from '../config/cube.json';
import devCfg from '../config/dev.json';
import banner from './asciibanner';

const nodeEnv = process.env.NODE_ENV;
const profile = process.env.PROFILE;
const language = process.env.LANGUAGE;

let cfg;

if (nodeEnv === 'production') {
  if (profile === 'cloud') {
    console.log(banner.cloud);
    cfg = {
      ...defaultCfg,
      ...cloudCfg,
      profile,
    };
  } else if (profile === 'cube') {
    console.log(banner.cube);
    console.log('language: ', language || 'multi-lang');
    window.env = 'cube';
    cfg = {
      ...defaultCfg,
      ...cubeCfg,
      profile,
      language,
    };
  }
} else {
  cfg = {
    ...defaultCfg,
    ...devCfg,
  };
  if (cfg.profile === 'cloud') {
    console.log(banner.devCloud);
  } else {
    console.log(banner.devCube);
  }
}

export default {
  ...cfg,
};




// WEBPACK FOOTER //
// ./src/config.js